/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvoiceStatus
 */
export interface InvoiceStatus {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    facility_id?: string | null;
    /**
     * 
     */
    due_date: string;
}

/**
 * Check if a given object implements the InvoiceStatus interface.
 */
export function instanceOfInvoiceStatus(value: object): value is InvoiceStatus {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('due_date' in value) || value['due_date'] === undefined) return false;
    return true;
}

export function InvoiceStatusFromJSON(json: any): InvoiceStatus {
    return InvoiceStatusFromJSONTyped(json, false);
}

export function InvoiceStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'facility_id': json['facility_id'] === undefined ? undefined : json['facility_id'] === null ? null : json['facility_id'],
        'due_date': json['due_date'],
    };
}

export function InvoiceStatusToJSON(json: any): InvoiceStatus {
    return InvoiceStatusToJSONTyped(json, false);
}

export function InvoiceStatusToJSONTyped(value?: InvoiceStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'facility_id': value['facility_id'],
        'due_date': value['due_date'],
    };
}

